import dayjs from 'dayjs'
import { z } from 'zod'
import { DEFAULT_PAGE_SEARCH as DEFAULT_ORDER_GROUP_LIST_SEARCH } from '@/const/list.ts'
import { createdAtSortSearchShape, toSearchArray } from '@/utils/list-query.ts'

export type OrderGroupListSearch = {
  current: number
  pageSize: number
  id?: number
  keyword?: string
  customerId?: number[]
  customerKeyword?: string
  creatorKeyword?: string
  createdFrom?: string
  createdTo?: string
  sortField?: 'createdAt'
  sortOrder?: 'asc' | 'desc'
}
export { DEFAULT_PAGE_SEARCH as DEFAULT_ORDER_GROUP_LIST_SEARCH } from '@/const/list.ts'

const dateTimeStringSchema = z.string().refine((value) => dayjs(value).isValid())

export const orderGroupListSearchSchema = z.object({
  current: z.coerce.number().int().min(1).catch(DEFAULT_ORDER_GROUP_LIST_SEARCH.current),
  pageSize: z.coerce.number().int().min(1).max(100).catch(DEFAULT_ORDER_GROUP_LIST_SEARCH.pageSize),
  id: z.coerce.number().int().positive().optional().catch(undefined),
  keyword: z.string().trim().max(255).optional().catch(undefined),
  customerId: z
    .preprocess(toSearchArray, z.array(z.coerce.number().int().positive()).min(1).max(100).optional())
    .catch(undefined),
  customerKeyword: z.string().trim().max(255).optional().catch(undefined),
  creatorKeyword: z.string().trim().max(255).optional().catch(undefined),
  createdFrom: dateTimeStringSchema.optional().catch(undefined),
  createdTo: dateTimeStringSchema.optional().catch(undefined),
  ...createdAtSortSearchShape
})
